import { render, staticRenderFns } from "./buy_fiat.vue?vue&type=template&id=52a779db&scoped=true"
import script from "./buy_fiat.vue?vue&type=script&lang=js"
export * from "./buy_fiat.vue?vue&type=script&lang=js"
import style0 from "./buy_fiat.vue?vue&type=style&index=0&id=52a779db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a779db",
  null
  
)

export default component.exports